function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueJsonPretty = t() : e.VueJsonPretty = t();
}(this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 67);
  }([function (e, t) {
    var n = e.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = n);
  }, function (e, t, n) {
    var r = n(25)("wks"),
        o = n(27),
        i = n(2).Symbol,
        a = "function" == typeof i;
    (e.exports = function (e) {
      return r[e] || (r[e] = a && i[e] || (a ? i : o)("Symbol." + e));
    }).store = r;
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (e, t, n) {
    e.exports = !n(8)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(2),
        o = n(0),
        i = n(19),
        a = n(5),
        s = n(9),
        u = function u(e, t, n) {
      var l,
          c,
          f,
          p = e & u.F,
          d = e & u.G,
          h = e & u.S,
          v = e & u.P,
          m = e & u.B,
          y = e & u.W,
          b = d ? o : o[t] || (o[t] = {}),
          g = b.prototype,
          _ = d ? r : h ? r[t] : (r[t] || {}).prototype;

      for (l in d && (n = t), n) {
        (c = !p && _ && void 0 !== _[l]) && s(b, l) || (f = c ? _[l] : n[l], b[l] = d && "function" != typeof _[l] ? n[l] : m && c ? i(f, r) : y && _[l] == f ? function (e) {
          var t = function t(_t, n, r) {
            if (this instanceof e) {
              switch (arguments.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(_t);

                case 2:
                  return new e(_t, n);
              }

              return new e(_t, n, r);
            }

            return e.apply(this, arguments);
          };

          return t.prototype = e.prototype, t;
        }(f) : v && "function" == typeof f ? i(Function.call, f) : f, v && ((b.virtual || (b.virtual = {}))[l] = f, e & u.R && g && !g[l] && a(g, l, f)));
      }
    };

    u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, e.exports = u;
  }, function (e, t, n) {
    var r = n(6),
        o = n(13);
    e.exports = n(3) ? function (e, t, n) {
      return r.f(e, t, o(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(7),
        o = n(36),
        i = n(37),
        a = Object.defineProperty;
    t.f = n(3) ? Object.defineProperty : function (e, t, n) {
      if (r(e), t = i(t, !0), r(n), o) try {
        return a(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var r = n(12);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    var r = n(15);

    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    e.exports = {
      "default": n(62),
      __esModule: !0
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == _typeof(e) ? null !== e : "function" == typeof e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(39),
        o = n(28);

    e.exports = Object.keys || function (e) {
      return r(e, o);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    var r = n(25)("keys"),
        o = n(27);

    e.exports = function (e) {
      return r[e] || (r[e] = o(e));
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(35);

    e.exports = function (e, t, n) {
      if (r(e), void 0 === t) return e;

      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };

        case 3:
          return function (n, r, o) {
            return e.call(t, n, r, o);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t, n) {
    var r = n(12),
        o = n(2).document,
        i = r(o) && r(o.createElement);

    e.exports = function (e) {
      return i ? o.createElement(e) : {};
    };
  }, function (e, t, n) {
    var r = n(22),
        o = n(15);

    e.exports = function (e) {
      return r(o(e));
    };
  }, function (e, t, n) {
    var r = n(23);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == r(e) ? e.split("") : Object(e);
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var r = n(16),
        o = Math.min;

    e.exports = function (e) {
      return e > 0 ? o(r(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var r = n(0),
        o = n(2),
        i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
    (e.exports = function (e, t) {
      return i[e] || (i[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: r.version,
      mode: n(26) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
    };
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t, n) {
    var r = n(6).f,
        o = n(9),
        i = n(1)("toStringTag");

    e.exports = function (e, t, n) {
      e && !o(e = n ? e : e.prototype, i) && r(e, i, {
        configurable: !0,
        value: t
      });
    };
  }, function (e, t, n) {
    e.exports = {
      "default": n(33),
      __esModule: !0
    };
  }, function (e) {
    e.exports = JSON.parse('{"name":"vue-json-pretty","version":"1.7.1","description":"A JSON tree view component that is easy to use and also supports data selection.","author":"leezng <im.leezng@gmail.com>","main":"lib/vue-json-pretty.js","scripts":{"dev":"node build/dev-server.js","build":"node build/build.js","build:example":"cross-env EXAMPLE_ENV=true node build/build.js","e2e":"node test/e2e/runner.js","test":"npm run e2e","lint":"eslint --ext .js,.vue src test/e2e/specs example"},"repository":{"type":"git","url":"git@github.com:leezng/vue-json-pretty.git"},"homepage":"https://leezng.github.io/vue-json-pretty","keywords":["vue","json","format","pretty","vue-component"],"license":"MIT","bugs":{"url":"https://github.com/leezng/vue-json-pretty/issues"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.26.3","babel-loader":"7","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.7.0","babel-preset-stage-2":"^6.24.1","chalk":"^2.0.1","clean-webpack-plugin":"^3.0.0","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^6.0.2","cross-env":"^7.0.2","cross-spawn":"^5.0.1","css-loader":"^0.28.0","cssnano":"^3.10.0","eslint":"^7.3.1","eslint-friendly-formatter":"^4.0.1","eslint-loader":"^4.0.2","eslint-plugin-vue":"^6.2.2","eventsource-polyfill":"^0.9.6","express":"^4.17.1","file-loader":"^6.0.0","friendly-errors-webpack-plugin":"^1.7.0","html-webpack-plugin":"^4.3.0","http-proxy-middleware":"^0.17.3","less":"^3.11.3","less-loader":"^6.1.2","mini-css-extract-plugin":"^0.9.0","nightwatch":"^1.0.19","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^5.0.3","selenium-server":"^3.0.1","semver":"^5.3.0","shelljs":"^0.7.6","url-loader":"^4.1.0","vue":"^2.6.11","vue-loader":"^14.2.4","vue-style-loader":"^4.1.2","vue-template-compiler":"^2.6.11","webpack":"^4.43.0","webpack-bundle-analyzer":"^3.8.0","webpack-dev-middleware":"^3.7.2","webpack-hot-middleware":"^2.25.0","webpack-merge":"^4.1.0"},"engines":{"node":">= 10.0.0","npm":">= 5.0.0"},"browserslist":["> 1%","last 10 versions","not ie <= 11"],"files":["lib"],"dependencies":{}}');
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(44),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };

    t["default"] = function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return (0, i["default"])(e);
    };
  }, function (e, t, n) {
    n(34), e.exports = n(0).Object.assign;
  }, function (e, t, n) {
    var r = n(4);
    r(r.S + r.F, "Object", {
      assign: n(38)
    });
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, t, n) {
    e.exports = !n(3) && !n(8)(function () {
      return 7 != Object.defineProperty(n(20)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(12);

    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, o;
      if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
      if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(3),
        o = n(14),
        i = n(42),
        a = n(43),
        s = n(10),
        u = n(22),
        l = Object.assign;
    e.exports = !l || n(8)(function () {
      var e = {},
          t = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
      return e[n] = 7, r.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != l({}, e)[n] || Object.keys(l({}, t)).join("") != r;
    }) ? function (e, t) {
      for (var n = s(e), l = arguments.length, c = 1, f = i.f, p = a.f; l > c;) {
        for (var d, h = u(arguments[c++]), v = f ? o(h).concat(f(h)) : o(h), m = v.length, y = 0; m > y;) {
          d = v[y++], r && !p.call(h, d) || (n[d] = h[d]);
        }
      }

      return n;
    } : l;
  }, function (e, t, n) {
    var r = n(9),
        o = n(21),
        i = n(40)(!1),
        a = n(17)("IE_PROTO");

    e.exports = function (e, t) {
      var n,
          s = o(e),
          u = 0,
          l = [];

      for (n in s) {
        n != a && r(s, n) && l.push(n);
      }

      for (; t.length > u;) {
        r(s, n = t[u++]) && (~i(l, n) || l.push(n));
      }

      return l;
    };
  }, function (e, t, n) {
    var r = n(21),
        o = n(24),
        i = n(41);

    e.exports = function (e) {
      return function (t, n, a) {
        var s,
            u = r(t),
            l = o(u.length),
            c = i(a, l);

        if (e && n != n) {
          for (; l > c;) {
            if ((s = u[c++]) != s) return !0;
          }
        } else for (; l > c; c++) {
          if ((e || c in u) && u[c] === n) return e || c || 0;
        }

        return !e && -1;
      };
    };
  }, function (e, t, n) {
    var r = n(16),
        o = Math.max,
        i = Math.min;

    e.exports = function (e, t) {
      return (e = r(e)) < 0 ? o(e + t, 0) : i(e, t);
    };
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t, n) {
    e.exports = {
      "default": n(45),
      __esModule: !0
    };
  }, function (e, t, n) {
    n(46), n(55), e.exports = n(0).Array.from;
  }, function (e, t, n) {
    "use strict";

    var r = n(47)(!0);
    n(48)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
          t = this._t,
          n = this._i;
      return n >= t.length ? {
        value: void 0,
        done: !0
      } : (e = r(t, n), this._i += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, t, n) {
    var r = n(16),
        o = n(15);

    e.exports = function (e) {
      return function (t, n) {
        var i,
            a,
            s = String(o(t)),
            u = r(n),
            l = s.length;
        return u < 0 || u >= l ? e ? "" : void 0 : (i = s.charCodeAt(u)) < 55296 || i > 56319 || u + 1 === l || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? e ? s.charAt(u) : i : e ? s.slice(u, u + 2) : a - 56320 + (i - 55296 << 10) + 65536;
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(26),
        o = n(4),
        i = n(49),
        a = n(5),
        s = n(18),
        u = n(50),
        l = n(29),
        c = n(54),
        f = n(1)("iterator"),
        p = !([].keys && "next" in [].keys()),
        d = function d() {
      return this;
    };

    e.exports = function (e, t, n, h, v, m, y) {
      u(n, t, h);

      var b,
          g,
          _,
          x = function x(e) {
        if (!p && e in C) return C[e];

        switch (e) {
          case "keys":
          case "values":
            return function () {
              return new n(this, e);
            };
        }

        return function () {
          return new n(this, e);
        };
      },
          k = t + " Iterator",
          w = "values" == v,
          j = !1,
          C = e.prototype,
          S = C[f] || C["@@iterator"] || v && C[v],
          O = S || x(v),
          A = v ? w ? x("entries") : O : void 0,
          M = "Array" == t && C.entries || S;

      if (M && (_ = c(M.call(new e()))) !== Object.prototype && _.next && (l(_, k, !0), r || "function" == typeof _[f] || a(_, f, d)), w && S && "values" !== S.name && (j = !0, O = function O() {
        return S.call(this);
      }), r && !y || !p && !j && C[f] || a(C, f, O), s[t] = O, s[k] = d, v) if (b = {
        values: w ? O : x("values"),
        keys: m ? O : x("keys"),
        entries: A
      }, y) for (g in b) {
        g in C || i(C, g, b[g]);
      } else o(o.P + o.F * (p || j), t, b);
      return b;
    };
  }, function (e, t, n) {
    e.exports = n(5);
  }, function (e, t, n) {
    "use strict";

    var r = n(51),
        o = n(13),
        i = n(29),
        a = {};
    n(5)(a, n(1)("iterator"), function () {
      return this;
    }), e.exports = function (e, t, n) {
      e.prototype = r(a, {
        next: o(1, n)
      }), i(e, t + " Iterator");
    };
  }, function (e, t, n) {
    var r = n(7),
        o = n(52),
        i = n(28),
        a = n(17)("IE_PROTO"),
        s = function s() {},
        _u = function u() {
      var e,
          t = n(20)("iframe"),
          r = i.length;

      for (t.style.display = "none", n(53).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _u = e.F; r--;) {
        delete _u.prototype[i[r]];
      }

      return _u();
    };

    e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (s.prototype = r(e), n = new s(), s.prototype = null, n[a] = e) : n = _u(), void 0 === t ? n : o(n, t);
    };
  }, function (e, t, n) {
    var r = n(6),
        o = n(7),
        i = n(14);
    e.exports = n(3) ? Object.defineProperties : function (e, t) {
      o(e);

      for (var n, a = i(t), s = a.length, u = 0; s > u;) {
        r.f(e, n = a[u++], t[n]);
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(2).document;
    e.exports = r && r.documentElement;
  }, function (e, t, n) {
    var r = n(9),
        o = n(10),
        i = n(17)("IE_PROTO"),
        a = Object.prototype;

    e.exports = Object.getPrototypeOf || function (e) {
      return e = o(e), r(e, i) ? e[i] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(19),
        o = n(4),
        i = n(10),
        a = n(56),
        s = n(57),
        u = n(24),
        l = n(58),
        c = n(59);
    o(o.S + o.F * !n(61)(function (e) {
      Array.from(e);
    }), "Array", {
      from: function from(e) {
        var t,
            n,
            o,
            f,
            p = i(e),
            d = "function" == typeof this ? this : Array,
            h = arguments.length,
            v = h > 1 ? arguments[1] : void 0,
            m = void 0 !== v,
            y = 0,
            b = c(p);
        if (m && (v = r(v, h > 2 ? arguments[2] : void 0, 2)), null == b || d == Array && s(b)) for (n = new d(t = u(p.length)); t > y; y++) {
          l(n, y, m ? v(p[y], y) : p[y]);
        } else for (f = b.call(p), n = new d(); !(o = f.next()).done; y++) {
          l(n, y, m ? a(f, v, [o.value, y], !0) : o.value);
        }
        return n.length = y, n;
      }
    });
  }, function (e, t, n) {
    var r = n(7);

    e.exports = function (e, t, n, o) {
      try {
        return o ? t(r(n)[0], n[1]) : t(n);
      } catch (t) {
        var i = e["return"];
        throw void 0 !== i && r(i.call(e)), t;
      }
    };
  }, function (e, t, n) {
    var r = n(18),
        o = n(1)("iterator"),
        i = Array.prototype;

    e.exports = function (e) {
      return void 0 !== e && (r.Array === e || i[o] === e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(13);

    e.exports = function (e, t, n) {
      t in e ? r.f(e, t, o(0, n)) : e[t] = n;
    };
  }, function (e, t, n) {
    var r = n(60),
        o = n(1)("iterator"),
        i = n(18);

    e.exports = n(0).getIteratorMethod = function (e) {
      if (null != e) return e[o] || e["@@iterator"] || i[r(e)];
    };
  }, function (e, t, n) {
    var r = n(23),
        o = n(1)("toStringTag"),
        i = "Arguments" == r(function () {
      return arguments;
    }());

    e.exports = function (e) {
      var t, n, a;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), o)) ? n : i ? r(t) : "Object" == (a = r(t)) && "function" == typeof t.callee ? "Arguments" : a;
    };
  }, function (e, t, n) {
    var r = n(1)("iterator"),
        o = !1;

    try {
      var i = [7][r]();
      i["return"] = function () {
        o = !0;
      }, Array.from(i, function () {
        throw 2;
      });
    } catch (e) {}

    e.exports = function (e, t) {
      if (!t && !o) return !1;
      var n = !1;

      try {
        var i = [7],
            a = i[r]();
        a.next = function () {
          return {
            done: n = !0
          };
        }, i[r] = function () {
          return a;
        }, e(i);
      } catch (e) {}

      return n;
    };
  }, function (e, t, n) {
    n(63), e.exports = n(0).Object.keys;
  }, function (e, t, n) {
    var r = n(10),
        o = n(14);
    n(64)("keys", function () {
      return function (e) {
        return o(r(e));
      };
    });
  }, function (e, t, n) {
    var r = n(4),
        o = n(0),
        i = n(8);

    e.exports = function (e, t) {
      var n = (o.Object || {})[e] || Object[e],
          a = {};
      a[e] = t(n), r(r.S + r.F * i(function () {
        n(1);
      }), "Object", a);
    };
  }, function (e, t, n) {
    var r = n(66);
    "string" == typeof r && (r = [[e.i, r, ""]]), r.locals && (e.exports = r.locals);
    (0, n(68)["default"])("4e38e324", r, !0, {});
  }, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(30),
        o = n.n(r),
        i = n(31),
        a = n(32),
        s = n.n(a),
        u = n(11),
        l = n.n(u);

    function c(e) {
      return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
    }

    function f(e, t, n, r, o, i, a, s) {
      var u = _typeof((e = e || {})["default"]);

      "object" !== u && "function" !== u || (e = e["default"]);
      var l,
          c = "function" == typeof e ? e.options : e;
      if (t && (c.render = t, c.staticRenderFns = n, c._compiled = !0), r && (c.functional = !0), i && (c._scopeId = i), a ? (l = function l(e) {
        (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), o && o.call(this, e), e && e._registeredComponents && e._registeredComponents.add(a);
      }, c._ssrRegister = l) : o && (l = s ? function () {
        o.call(this, this.$root.$options.shadowRoot);
      } : o), l) if (c.functional) {
        c._injectStyles = l;
        var f = c.render;

        c.render = function (e, t) {
          return l.call(t), f(e, t);
        };
      } else {
        var p = c.beforeCreate;
        c.beforeCreate = p ? [].concat(p, l) : [l];
      }
      return {
        exports: e,
        options: c
      };
    }

    var p = f({
      props: {
        showDoubleQuotes: Boolean,
        parentData: {
          type: [String, Number, Boolean, Array, Object],
          "default": null
        },
        data: {
          type: [String, Number, Boolean],
          "default": ""
        },
        showComma: Boolean,
        currentKey: {
          type: [Number, String],
          "default": ""
        },
        customValueFormatter: {
          type: Function,
          "default": null
        }
      },
      computed: {
        valueClass: function valueClass() {
          return "vjs-value vjs-value__" + this.dataType;
        },
        dataType: function dataType() {
          return c(this.data);
        }
      },
      methods: {
        defaultFormatter: function defaultFormatter(e) {
          var t = e + "";
          return "string" === this.dataType && (t = '"' + t + '"'), t;
        },
        customFormatter: function customFormatter(e) {
          return this.customValueFormatter ? this.customValueFormatter(e, this.currentKey, this.parentData, this.defaultFormatter(e)) : this.defaultFormatter(e);
        }
      }
    }, function () {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return n("div", [e._t("default"), e._v(" "), e.customValueFormatter ? n("span", {
        "class": e.valueClass,
        domProps: {
          innerHTML: e._s(e.customFormatter(e.data))
        }
      }) : n("span", {
        "class": e.valueClass
      }, [e._v(e._s(e.defaultFormatter(e.data)))]), e.showComma ? n("span", [e._v(",")]) : e._e()], 2);
    }, [], !1, null, null, null).exports,
        d = f({
      props: {
        value: {
          type: Boolean,
          "default": !1
        }
      },
      data: function data() {
        return {
          focus: !1
        };
      },
      computed: {
        model: {
          get: function get() {
            return this.value;
          },
          set: function set(e) {
            this.$emit("input", e);
          }
        }
      }
    }, function () {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return n("label", {
        "class": ["vjs-checkbox", e.value ? "is-checked" : ""],
        on: {
          click: function click(e) {
            e.stopPropagation();
          }
        }
      }, [n("span", {
        staticClass: "vjs-checkbox__inner"
      }), e._v(" "), n("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: e.model,
          expression: "model"
        }],
        staticClass: "vjs-checkbox__original",
        attrs: {
          type: "checkbox"
        },
        domProps: {
          checked: Array.isArray(e.model) ? e._i(e.model, null) > -1 : e.model
        },
        on: {
          change: [function (t) {
            var n = e.model,
                r = t.target,
                o = !!r.checked;

            if (Array.isArray(n)) {
              var i = e._i(n, null);

              r.checked ? i < 0 && (e.model = n.concat([null])) : i > -1 && (e.model = n.slice(0, i).concat(n.slice(i + 1)));
            } else e.model = o;
          }, function (t) {
            return e.$emit("change", e.model);
          }],
          focus: function focus(t) {
            e.focus = !0;
          },
          blur: function blur(t) {
            e.focus = !1;
          }
        }
      })]);
    }, [], !1, null, null, null).exports,
        h = f({
      props: {
        path: {
          type: String,
          "default": ""
        },
        value: {
          type: String,
          "default": ""
        }
      },
      data: function data() {
        return {
          focus: !1
        };
      },
      computed: {
        currentPath: function currentPath() {
          return this.path;
        },
        model: {
          get: function get() {
            return this.value;
          },
          set: function set(e) {
            this.$emit("input", e);
          }
        }
      },
      methods: {
        change: function change() {
          this.$emit("change", this.model);
        }
      }
    }, function () {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return n("label", {
        "class": ["vjs-radio", e.model === e.currentPath ? "is-checked" : ""],
        on: {
          click: function click(e) {
            e.stopPropagation();
          }
        }
      }, [n("span", {
        staticClass: "vjs-radio__inner"
      }), e._v(" "), n("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: e.model,
          expression: "model"
        }],
        staticClass: "vjs-radio__original",
        attrs: {
          type: "radio"
        },
        domProps: {
          value: e.currentPath,
          checked: e._q(e.model, e.currentPath)
        },
        on: {
          change: [function (t) {
            e.model = e.currentPath;
          }, e.change],
          focus: function focus(t) {
            e.focus = !0;
          },
          blur: function blur(t) {
            e.focus = !1;
          }
        }
      })]);
    }, [], !1, null, null, null).exports,
        v = {
      props: {
        visible: {
          required: !0,
          type: Boolean
        },
        data: {
          required: !0
        },
        showComma: Boolean,
        collapsedOnClickBrackets: Boolean
      },
      computed: {
        dataVisiable: {
          get: function get() {
            return this.visible;
          },
          set: function set(e) {
            this.collapsedOnClickBrackets && this.$emit("update:visible", e);
          }
        }
      },
      methods: {
        toggleBrackets: function toggleBrackets() {
          this.dataVisiable = !this.dataVisiable;
        },
        bracketsFormatter: function bracketsFormatter(e) {
          return this.showComma ? e + "," : e;
        }
      }
    },
        m = f({
      mixins: [v],
      props: {
        showLength: Boolean
      },
      methods: {
        closedBracketsGenerator: function closedBracketsGenerator(e) {
          var t = Array.isArray(e) ? "[...]" : "{...}";
          return this.bracketsFormatter(t);
        },
        lengthGenerator: function lengthGenerator(e) {
          return " // " + (Array.isArray(e) ? e.length + " items" : l()(e).length + " keys");
        }
      }
    }, function () {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return n("div", [e._t("default"), e._v(" "), n("span", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: e.dataVisiable,
          expression: "dataVisiable"
        }],
        staticClass: "vjs-tree__brackets",
        on: {
          click: function click(t) {
            return t.stopPropagation(), e.toggleBrackets(t);
          }
        }
      }, [e._v("\n    " + e._s(Array.isArray(e.data) ? "[" : "{") + "\n  ")]), e._v(" "), n("span", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !e.dataVisiable,
          expression: "!dataVisiable"
        }]
      }, [n("span", {
        staticClass: "vjs-tree__brackets",
        on: {
          click: function click(t) {
            return t.stopPropagation(), e.toggleBrackets(t);
          }
        }
      }, [e._v("\n      " + e._s(e.closedBracketsGenerator(e.data)) + "\n    ")]), e._v(" "), e.showLength ? n("span", {
        staticClass: "vjs-comment"
      }, [e._v("\n      " + e._s(e.lengthGenerator(e.data)) + "\n    ")]) : e._e()])], 2);
    }, [], !1, null, null, null).exports,
        y = f({
      mixins: [v]
    }, function () {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return n("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: e.dataVisiable,
          expression: "dataVisiable"
        }]
      }, [n("span", {
        staticClass: "vjs-tree__brackets",
        on: {
          click: function click(t) {
            return t.stopPropagation(), e.toggleBrackets(t);
          }
        }
      }, [e._v("\n    " + e._s(e.bracketsFormatter(Array.isArray(e.data) ? "]" : "}")) + "\n  ")])]);
    }, [], !1, null, null, null),
        b = f({
      name: "VueJsonPretty",
      components: {
        SimpleText: p,
        VueCheckbox: d,
        VueRadio: h,
        BracketsLeft: m,
        BracketsRight: y.exports
      },
      props: {
        data: {
          type: [String, Number, Boolean, Array, Object],
          "default": null
        },
        deep: {
          type: Number,
          "default": 1 / 0
        },
        showLength: {
          type: Boolean,
          "default": !1
        },
        showDoubleQuotes: {
          type: Boolean,
          "default": !0
        },
        path: {
          type: String,
          "default": "root"
        },
        selectableType: {
          type: String,
          "default": ""
        },
        showSelectController: {
          type: Boolean,
          "default": !1
        },
        showLine: {
          type: Boolean,
          "default": !0
        },
        selectOnClickNode: {
          type: Boolean,
          "default": !0
        },
        value: {
          type: [Array, String],
          "default": function _default() {
            return "";
          }
        },
        pathSelectable: {
          type: Function,
          "default": function _default() {
            return !0;
          }
        },
        highlightMouseoverNode: {
          type: Boolean,
          "default": !1
        },
        highlightSelectedNode: {
          type: Boolean,
          "default": !0
        },
        collapsedOnClickBrackets: {
          type: Boolean,
          "default": !0
        },
        customValueFormatter: {
          type: Function,
          "default": null
        },
        parentData: {
          type: [String, Number, Boolean, Array, Object],
          "default": null
        },
        currentDeep: {
          type: Number,
          "default": 1
        },
        currentKey: {
          type: [Number, String],
          "default": ""
        }
      },
      data: function data() {
        return {
          visible: this.currentDeep <= this.deep,
          isMouseover: !1,
          currentCheckboxVal: !!Array.isArray(this.value) && this.value.includes(this.path)
        };
      },
      computed: {
        model: {
          get: function get() {
            var e = "multiple" === this.selectableType ? [] : "single" === this.selectableType ? "" : null;
            return this.value || e;
          },
          set: function set(e) {
            this.$emit("input", e);
          }
        },
        lastKey: function lastKey() {
          if (Array.isArray(this.parentData)) return this.parentData.length - 1;

          if (this.isObject(this.parentData)) {
            var e = l()(this.parentData);
            return e[e.length - 1];
          }

          return "";
        },
        notLastKey: function notLastKey() {
          return this.currentKey !== this.lastKey;
        },
        selectable: function selectable() {
          return this.pathSelectable(this.path, this.data) && (this.isMultiple || this.isSingle);
        },
        isMultiple: function isMultiple() {
          return "multiple" === this.selectableType;
        },
        isSingle: function isSingle() {
          return "single" === this.selectableType;
        },
        isSelected: function isSelected() {
          return this.isMultiple ? this.model.includes(this.path) : !!this.isSingle && this.model === this.path;
        },
        prettyKey: function prettyKey() {
          return this.showDoubleQuotes ? '"' + this.currentKey + '"' : this.currentKey;
        },
        propsError: function propsError() {
          return this.selectableType && !this.selectOnClickNode && !this.showSelectController ? "When selectableType is not null, selectOnClickNode and showSelectController cannot be false at the same time, because this will cause the selection to fail." : "";
        }
      },
      watch: {
        deep: function deep(e) {
          this.visible = this.currentDeep <= e;
        },
        propsError: {
          handler: function handler(e) {
            if (e) throw new Error("[vue-json-pretty] " + e);
          },
          immediate: !0
        }
      },
      methods: {
        handleValueChange: function handleValueChange(e) {
          var t = this;

          if (!this.isMultiple || "checkbox" !== e && "tree" !== e) {
            if (this.isSingle && ("radio" === e || "tree" === e) && this.model !== this.path) {
              var n = this.model,
                  r = this.path;
              this.model = r, this.$emit("change", r, n);
            }
          } else {
            var o = this.model.findIndex(function (e) {
              return e === t.path;
            }),
                i = [].concat(s()(this.model));
            -1 !== o ? this.model.splice(o, 1) : this.model.push(this.path), "checkbox" !== e && (this.currentCheckboxVal = !this.currentCheckboxVal), this.$emit("change", this.model, i);
          }
        },
        handleClick: function handleClick(e) {
          e._uid && e._uid !== this._uid || (e._uid = this._uid, this.$emit("click", this.path, this.data), this.selectable && this.selectOnClickNode && this.handleValueChange("tree"));
        },
        handleItemClick: function handleItemClick(e, t) {
          this.$emit("click", e, t);
        },
        handleItemChange: function handleItemChange(e, t) {
          this.selectable && this.$emit("change", e, t);
        },
        handleMouseover: function handleMouseover() {
          this.highlightMouseoverNode && (this.selectable || "" === this.selectableType) && (this.isMouseover = !0);
        },
        handleMouseout: function handleMouseout() {
          this.highlightMouseoverNode && (this.selectable || "" === this.selectableType) && (this.isMouseover = !1);
        },
        isObject: function isObject(e) {
          return "object" === c(e);
        },
        getChildPath: function getChildPath(e) {
          return this.path + (Array.isArray(this.data) ? "[" + e + "]" : e.includes(".") ? '["' + e + '"]' : "." + e);
        }
      },
      errorCaptured: function errorCaptured() {
        return !1;
      }
    }, function () {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return n("div", {
        "class": {
          "vjs-tree": !0,
          "has-selectable-control": e.isMultiple || e.showSelectController,
          "is-root": 1 === e.currentDeep,
          "is-selectable": e.selectable,
          "is-selected": e.isSelected,
          "is-highlight-selected": e.isSelected && e.highlightSelectedNode,
          "is-mouseover": e.isMouseover
        },
        on: {
          click: e.handleClick,
          mouseover: function mouseover(t) {
            return t.stopPropagation(), e.handleMouseover(t);
          },
          mouseout: function mouseout(t) {
            return t.stopPropagation(), e.handleMouseout(t);
          }
        }
      }, [e.showSelectController && e.selectable ? [e.isMultiple ? n("vue-checkbox", {
        on: {
          change: function change(t) {
            return e.handleValueChange("checkbox");
          }
        },
        model: {
          value: e.currentCheckboxVal,
          callback: function callback(t) {
            e.currentCheckboxVal = t;
          },
          expression: "currentCheckboxVal"
        }
      }) : e.isSingle ? n("vue-radio", {
        attrs: {
          path: e.path
        },
        on: {
          change: function change(t) {
            return e.handleValueChange("radio");
          }
        },
        model: {
          value: e.model,
          callback: function callback(t) {
            e.model = t;
          },
          expression: "model"
        }
      }) : e._e()] : e._e(), e._v(" "), Array.isArray(e.data) || e.isObject(e.data) ? [n("brackets-left", {
        attrs: {
          visible: e.visible,
          data: e.data,
          "show-length": e.showLength,
          "collapsed-on-click-brackets": e.collapsedOnClickBrackets,
          "show-comma": e.notLastKey
        },
        on: {
          "update:visible": function updateVisible(t) {
            e.visible = t;
          }
        }
      }, [e.currentDeep > 1 && !Array.isArray(e.parentData) ? n("span", {
        staticClass: "vjs-key"
      }, [e._v("\n        " + e._s(e.prettyKey) + ":\n      ")]) : e._e()]), e._v(" "), e._l(e.data, function (t, r) {
        return n("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: e.visible,
            expression: "visible"
          }],
          key: r,
          "class": {
            "vjs-tree__content": !0,
            "has-line": e.showLine
          }
        }, [n("vue-json-pretty", {
          attrs: {
            "parent-data": e.data,
            data: t,
            deep: e.deep,
            "show-length": e.showLength,
            "show-double-quotes": e.showDoubleQuotes,
            "show-line": e.showLine,
            "highlight-mouseover-node": e.highlightMouseoverNode,
            "highlight-selected-node": e.highlightSelectedNode,
            path: e.getChildPath(r),
            "path-selectable": e.pathSelectable,
            "selectable-type": e.selectableType,
            "show-select-controller": e.showSelectController,
            "select-on-click-node": e.selectOnClickNode,
            "collapsed-on-click-brackets": e.collapsedOnClickBrackets,
            "current-key": r,
            "current-deep": e.currentDeep + 1,
            "custom-value-formatter": e.customValueFormatter
          },
          on: {
            click: e.handleItemClick,
            change: e.handleItemChange
          },
          model: {
            value: e.model,
            callback: function callback(t) {
              e.model = t;
            },
            expression: "model"
          }
        })], 1);
      }), e._v(" "), n("brackets-right", {
        attrs: {
          visible: e.visible,
          data: e.data,
          "collapsed-on-click-brackets": e.collapsedOnClickBrackets,
          "show-comma": e.notLastKey
        },
        on: {
          "update:visible": function updateVisible(t) {
            e.visible = t;
          }
        }
      })] : n("simple-text", {
        attrs: {
          "custom-value-formatter": e.customValueFormatter,
          "show-double-quotes": e.showDoubleQuotes,
          "show-comma": e.notLastKey,
          "parent-data": e.parentData,
          data: e.data,
          "current-key": e.currentKey
        }
      }, [e.parentData && e.currentKey && !Array.isArray(e.parentData) ? n("span", {
        staticClass: "vjs-key"
      }, [e._v("\n      " + e._s(e.prettyKey) + ":\n    ")]) : e._e()])], 2);
    }, [], !1, null, null, null).exports;
    n(65), t["default"] = o()({}, b, {
      version: i.version
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      for (var n = [], r = {}, o = 0; o < t.length; o++) {
        var i = t[o],
            a = i[0],
            s = {
          id: e + ":" + o,
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    n.r(t), n.d(t, "default", function () {
      return d;
    });
    var o = "undefined" != typeof document;
    if ("undefined" != typeof DEBUG && DEBUG && !o) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");

    var i = {},
        a = o && (document.head || document.getElementsByTagName("head")[0]),
        s = null,
        u = 0,
        l = !1,
        c = function c() {},
        f = null,
        p = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

    function d(e, t, n, o) {
      l = n, f = o || {};
      var a = r(e, t);
      return h(a), function (t) {
        for (var n = [], o = 0; o < a.length; o++) {
          var s = a[o];
          (u = i[s.id]).refs--, n.push(u);
        }

        t ? h(a = r(e, t)) : a = [];

        for (o = 0; o < n.length; o++) {
          var u;

          if (0 === (u = n[o]).refs) {
            for (var l = 0; l < u.parts.length; l++) {
              u.parts[l]();
            }

            delete i[u.id];
          }
        }
      };
    }

    function h(e) {
      for (var t = 0; t < e.length; t++) {
        var n = e[t],
            r = i[n.id];

        if (r) {
          r.refs++;

          for (var o = 0; o < r.parts.length; o++) {
            r.parts[o](n.parts[o]);
          }

          for (; o < n.parts.length; o++) {
            r.parts.push(m(n.parts[o]));
          }

          r.parts.length > n.parts.length && (r.parts.length = n.parts.length);
        } else {
          var a = [];

          for (o = 0; o < n.parts.length; o++) {
            a.push(m(n.parts[o]));
          }

          i[n.id] = {
            id: n.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function v() {
      var e = document.createElement("style");
      return e.type = "text/css", a.appendChild(e), e;
    }

    function m(e) {
      var t,
          n,
          r = document.querySelector('style[data-vue-ssr-id~="' + e.id + '"]');

      if (r) {
        if (l) return c;
        r.parentNode.removeChild(r);
      }

      if (p) {
        var o = u++;
        r = s || (s = v()), t = g.bind(null, r, o, !1), n = g.bind(null, r, o, !0);
      } else r = v(), t = _.bind(null, r), n = function n() {
        r.parentNode.removeChild(r);
      };

      return t(e), function (r) {
        if (r) {
          if (r.css === e.css && r.media === e.media && r.sourceMap === e.sourceMap) return;
          t(e = r);
        } else n();
      };
    }

    var y,
        b = (y = [], function (e, t) {
      return y[e] = t, y.filter(Boolean).join("\n");
    });

    function g(e, t, n, r) {
      var o = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = b(t, o);else {
        var i = document.createTextNode(o),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }

    function _(e, t) {
      var n = t.css,
          r = t.media,
          o = t.sourceMap;
      if (r && e.setAttribute("media", r), f.ssrId && e.setAttribute("data-vue-ssr-id", t.id), o && (n += "\n/*# sourceURL=" + o.sources[0] + " */", n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */"), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(n));
      }
    }
  }]);
});